



















import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import type { ShoppableImageModel } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'InstalikeContent',
  components: {
    VaimoHeading: () => import('atoms/VaimoHeading.vue'),
    VaimoButtons: () => import('molecules/VaimoButtons.vue')
  },
  props: {
    sectionData: {
      required: true,
      type: Object as PropType<ShoppableImageModel>
    }
  }
});
